import { useNavigate, useParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';

import {
  appPublicDatasetsPath,
  appPublicPath,
  appRunPath,
  appSessionPath,
} from '../../utils/constants';
import { Run } from '../Run';

const PublicRun = () => {
  const { datasetShareToken, runId, sessionId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen flex-col px-4 pt-4">
      <Breadcrumbs />
      <div className="-mx-4 mt-4 h-[1px] bg-tertiary" />
      <Run
        runId={runId}
        shareTokenProp={{ datasetShareToken }}
        navigateToRun={(
          runId: string,
          trace_id?: string,
          start_time?: string
        ) => {
          navigate(
            `/${appPublicPath}/${datasetShareToken}/${appPublicDatasetsPath}/${sessionId}/${appSessionPath}/${appRunPath}/${runId}?trace_id=${trace_id}&start_time=${start_time}`
          );
        }}
      />
    </div>
  );
};

export default PublicRun;
